module.exports = __webpack_public_path__ + "static/media/jdbgmgr_100.5778697a.ico";